// 课程
export const classesList = [{
    id: 'class_1',
    name: '105分钟综合孕期瑜伽',
    en_name: '105 MINUTES COMPREHENSIVE PREGNANCY YOGA',
    start_time: '2019.6.4 14:00',
    address: 'A教室',
    total_count: 10,
    booked_count: 8,
    status: 1, // 1 预约, 2 取消预约, 3 已预约
    author_id: 'author_1'
}, {
    id: 'class_2',
    name: '105分钟综合孕期瑜伽',
    en_name: '105 MINUTES COMPREHENSIVE PREGNANCY YOGA',
    start_time: '2019.6.4 14:00',
    address: 'A教室',
    total_count: 10,
    booked_count: 8,
    status: 2,
    author_id: 'author_2'

}, {
    id: 'class_3',
    name: '105分钟综合孕期瑜伽',
    en_name: '105 MINUTES COMPREHENSIVE PREGNANCY YOGA',
    start_time: '2019.6.4 14:00',
    address: 'A教室',
    total_count: 10,
    booked_count: 8,
    status: 3,
    author_id: 'author_3'

}, {
    id: 'class_4',
    name: '孕产瑜伽 30h',
    en_name: '30 HOURS POSTPARTUM YOGA',
    start_time: '2019.6.4 16:00',
    address: 'A教室',
    total_count: 10,
    booked_count: 12,
    status: 4, // 4 申请候补, 5 取消候补, 6 候补中, 7 候补成功
    author_id: 'author_4'

}, {
    id: 'class_5',
    name: '孕产瑜伽 30h',
    en_name: '30 HOURS POSTPARTUM YOGA',
    start_time: '2019.6.4 16:00',
    address: 'A教室',
    total_count: 10,
    booked_count: 12,
    status: 5,
    author_id: 'author_5'

}];

// 预约的课程
export const publicOrderClasses = [{
    id: 'public_order_1',
    type: 'postpartum', // 产后
    name: '产后阶段1',
    start_time: '2019.10.19 10:00',
    address: 'A教室',
    status: 7, // 候补成功
    total_count: 10,
    booked_count: 8,
    author_id: 'author_1'
}, {
    id: 'public_order_2',
    type: 'postpartum', // 产后
    name: '空中塑形',
    start_time: '2019.10.18 10:00',
    address: 'A教室',
    status: 6,
    total_count: 10,
    booked_count: 12,
    author_id: 'author_1'
}, {
    id: 'public_order_3',
    type: 'postpartum', // 产后
    name: '俄式塑形|独家引进俄罗斯女形体重塑课',
    start_time: '2019.10.17 10:00',
    address: 'A教室',
    status: 3,
    total_count: 10,
    booked_count: 8,
    author_id: 'author_1'

}];

export const teacherCommonClasses = [{
    id: 'public_order_1',
    type: 'postpartum', // 产后
    name: '产后阶段1',
    start_time: '2019.10.19 10:00',
    address: 'A教室',
    status: 7, // 候补成功
    total_count: 10,
    booked_count: 8,
    author_id: 'author_1'
}, {
    id: 'public_order_2',
    type: 'postpartum', // 产后
    name: '空中塑形',
    start_time: '2019.10.18 10:00',
    address: 'A教室',
    status: 7,
    total_count: 10,
    booked_count: 12,
    author_id: 'author_1'
}, {
    id: 'public_order_3',
    type: 'postpartum', // 产后
    name: '俄式塑形|独家引进俄罗斯女形体重塑课',
    start_time: '2019.10.17 10:00',
    address: 'A教室',
    status: 3,
    total_count: 10,
    booked_count: 8,
    author_id: 'author_1'
}];

export const publicHistoryOrder = [{
    id: 'public_order_4',
    type: 'pregnancy', // 孕期
    name: '孕产瑜伽 30h',
    start_time: '2019.5.18 14:00',
    address: 'A教室',
    status: 3
}];

export const teacherCommonHistoryOrder = [{
    id: 'teacher_common_1',
    type: 'pregnancy', // 孕期
    name: '孕产瑜伽 30h',
    start_time: '2019.5.18 14:00',
    address: 'A教室',
    status: 3
}, {
    id: 'teacher_common_2',
    type: 'pregnancy', // 孕期
    name: '孕产瑜伽 30h',
    start_time: '2019.5.18 14:00',
    address: 'A教室',
    status: 3
}, {
    id: 'teacher_common_3',
    type: 'pregnancy', // 孕期
    name: '孕产瑜伽 30h',
    start_time: '2019.5.18 14:00',
    address: 'A教室',
    status: 3
}];

export const privateOrderClasses = [{
    type: 'postpartum', // 产后
    author_name: '李建慧',
    author_id: 'author_1',
    start_time: '2019.10.19 10:00',
    address: 'A教室'
}, {
    type: 'postpartum', // 产后
    author_name: '李佳圆',
    author_id: 'author_2',
    start_time: '2019.10.19 10:00',
    address: 'A教室'
}, {
    type: 'postpartum', // 产后
    author_name: '李建慧',
    author_id: 'author_1',
    start_time: '2019.10.19 10:00',
    address: 'A教室'
}];

export const teacherPrivateClasses = [{
    author_name: '王梦婕',
    author_id: 'author_1',
    start_time: '2019.11.20 14:00',
    address: 'A教室'
}, {
    author_name: '林小妙',
    author_id: 'author_2',
    start_time: '2019.11.21 9:00',
    address: 'A教室'
}];

export const privateHistoryOrder = [{
    type: 'pregnancy', // 产前
    author_name: '张若冰',
    author_id: 'author_2',
    start_time: '2019.10.19 10:00',
    address: '私教3'
}];

export const teacherPrivateHistoryOrder = [{
    author_name: '郭沙沙',
    author_id: 'author_3',
    start_time: '2019.11.21 10:00',
    address: '私教3'
}];
// 按时间排的课程
export default [{
    date: '2019.10.8',
    week: '星期二',
    classes: classesList,
    img: '../static/img/'
}, {
    date: '2019.10.9',
    week: '星期三',
    classes: classesList,
    img: '../static/img/'

}, {
    date: '2019.10.10',
    week: '星期四',
    classes: classesList,

}, {
    date: '2019.10.11',
    week: '星期五',
    classes: classesList,
    img: '../static/img/'

}];


// WEBPACK FOOTER //
// ./src/__mock__/classes.js